<template>
  <van-dialog v-model="showModal"  :showConfirmButton= "false"  @close="close" id="base-notice-modal" >
    <div class="notice_text">
      完善资料能看到更多优秀异性
    </div>
    <a class="common-bg goto_base_info"  @click.stop="gotoBaseInfo()">立即完善个人资料</a>
    <div>
      <a class="cancle" @click="close" >以后再说 </a>
    </div>
  </van-dialog>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import wxApi from '@/utils/wxAuth'

  export default {
    name: 'baseNoticeModal',
    props: {
      show: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      showModal: {
        get () {
          return this.show
        },
        set (val) {
          this.$emit('close', val)
        }
      }
    },
    data () {
      return {
        isShowDialog: false,
        ensureText: '以后再说'
      }
    },
    methods: {
      gotoBaseInfo () {
        this.$nextTick(() => this.$emit('confirm'))
      },
      close () {
        this.showModal = false
      }
    }
  }
</script>

<style lang="scss">
  @import "@/assets/scss/constant.scss";
  #base-notice-modal {
    padding: 28px 36px 12px;
    text-align: center;
    .notice_text {
      font-size:32px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(155,155,161,1);
      line-height:48px;
    }
    .goto_base_info {
      display: block;
      margin: 36px 0;
      padding: 24px;
      color: #fff;
      font-size: 36px;
      line-height: 50px;
      border-radius: 100px;
    }
    .cancle{
      width:128px;
      height:32px;
      font-size:32px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(0,0,0,0.5);
      line-height:32px;
    }
  }
</style>
